import React from 'react';
import { Link } from '../../..';
import { StaticFooter } from '../Static';
import { sendClickEvent } from '../../utils/sendClickEvent';
import * as Styles from './styles';
import { LinksOldFooter } from '../../utils/links';
/**
 * Componente Footer do Design System OLX
 */
export const OldFooter = props => {
  const componentName = 'footer';
  return React.createElement(Styles.FooterWrapper, {
    id: "footer",
    "data-ds-component": "DS-Footer"
  }, React.createElement(Styles.Links, null, LinksOldFooter.map(props => React.createElement(Link, {
    key: props.name,
    dsParentName: componentName,
    href: props.href,
    variant: "grey",
    size: "small",
    onClick: () => sendClickEvent(props.clickEvent, componentName),
    "data-ds-component": "DS-Footer-Link"
  }, props.name))), React.createElement(StaticFooter, {
    componentName: componentName
  }));
};
export default OldFooter;